import { sr } from './Translations/sr';
import { lat } from './Translations/lat';

export const translations = {
  sr,
  lat,
};
